import { Colors, truncated } from "@flatfile/design-system";
import { FlexCenter } from "../../../common/UI/Flex.js";
import { TooltipContainerStyles, DisableSelection } from "../Styles.js";
import { TooltipStyles } from "../../Table/Styles.js";
import styled, { css } from "styled-components";
const Container = styled.div`
  ${TooltipContainerStyles}
  background: ${(props) => props.theme.backgroundColor};
  transition: border 300ms ease-in;
  position: absolute;
  ${(props) => props.isNewRowCell ? css`
          bottom: 1px;
          left: -1px;
          right: -1px;
          display: flex;
          flex-direction: column-reverse;
          border: 1px solid ${props.theme.cell.borderColor};
          border-bottom: none;
          border-top-left-radius: ${props.theme.tooltip.borderRadius};
          border-top-right-radius: ${props.theme.tooltip.borderRadius};
        ` : css`
          top: 0;
          left: -1px;
          right: -1px;
          display: flex;
          flex-direction: column;
          border: 1px solid ${props.theme.cell.borderColor};
          border-top: none;
          border-bottom-left-radius: ${props.theme.tooltip.borderRadius};
          border-bottom-right-radius: ${props.theme.tooltip.borderRadius};
        `}
`;
const Input = styled.input`
  background: ${Colors.Transparent};
  color: ${(props) => props.theme.cell.color};
  font-size: 12px;
  font-family: inherit;
  border: none;
  border-radius: ${(props) => props.theme.tooltip.borderRadius};
  padding: 2px 6px;
  height: 20px;
  width: 100%;

  &:focus {
    outline: none;
  }

  ::placeholder {
    color: ${(props) => props.theme.cell.secondaryColor};
    align-self: center;
  }

  :disabled {
    background-color: transparent;
  }
`;
const SearchBar = styled.div`
  ${FlexCenter};
  flex-wrap: wrap;
  padding: 5px 4px 5px 8px;
  position: relative;
  min-height: 31px;
  gap: 5px;
  ${({ isFirstColumn }) => isFirstColumn && "padding-left: 7px;"}
  ${({ isFirstNonHeaderRow }) => isFirstNonHeaderRow && "padding-top: 4px;"}
  ${({ isNewRowCell }) => isNewRowCell ? css`
          box-shadow: 0 -1px 0 0 ${Colors.Pigeon200};
        ` : css`
          box-shadow: 0 1px 0 0 ${Colors.Pigeon200};
        `}
`;
const StatusWrapper = styled.div`
  ${FlexCenter}
  min-height: 32px;
  padding: 0px 8px;
`;
const Status = styled.div`
  ${FlexCenter}
  ${DisableSelection}
  padding: 4px 8px;
  color: ${(props) => props.theme.lookupEditor.color};
  ${(props) => props.italic ? "font-style: italic;" : ""}
`;
const PillsWrapper = styled.div`
  ${FlexCenter}
  ${DisableSelection}
  flex-grow: 1;
  margin-right: 4px;
  position: relative;
  min-height: 21px;
  gap: 4px;
  overflow-x: hidden;

  ${(props) => props.editor && css`
      flex-wrap: wrap;
    `}
`;
const Pill = styled.div`
  ${FlexCenter}
  background-color: ${(props) => {
  if (props.error)
    return props.theme.cell.error.backgroundColor;
  if (props.warning)
    return props.theme.cell.warning.backgroundColor;
  return props.theme.lookupEditor.option.backgroundColor.active;
}};
  color: ${(props) => {
  if (props.error)
    return props.theme.cell.error.color;
  if (props.warning)
    return props.theme.cell.warning.color;
  return props.theme.cell.color;
}};
  border-radius: ${(props) => props.theme.lookupEditor.option.borderRadius.active};
  padding: 2px 8px;
  font-weight: 500;
  height: 20px;
  max-width: ${({ single }) => single ? "100%" : "50%"};
`;
const RemovePill = styled.div`
  ${FlexCenter}
  cursor: pointer;
  padding-left: 4px;
  opacity: 0.3;
`;
const ClipText = styled.div`
  ${truncated}
  max-width: 100%;
`;
const OptionImage = styled.div`
  width: 10px;
  height: 10px;
  background: url(${(props) => props.url});
  background-size: cover;
  border-radius: 5px;
  margin-right: 4px;
  display: none;
`;
const Option = styled.div`
  ${FlexCenter}
  ${DisableSelection}
  padding: 2px 8px;
  font-size: 12px;
  cursor: pointer;
  flex-grow: 0;
  flex-shrink: 0;
  min-height: 20px;

  &:hover,
  &:focus {
    background-color: ${(props) => props.theme.lookupEditor.option.backgroundColor.hover};
    border-radius: ${(props) => props.theme.lookupEditor.option.borderRadius.hover};
  }

  &:focus {
    outline: none;
  }
`;
const ListContainer = styled.div`
  padding: 4px 7px 4px;
  max-height: 120px;
  overflow-y: auto;
  ${(props) => props.isNewRowCell && css`
      border-bottom: none;
      border-top-left-radius: ${props.theme.tooltip.borderRadius};
      border-top-right-radius: ${props.theme.tooltip.borderRadius};
    `}
  ${(props) => !props.isNewRowCell && css`
      border-top: none;
      border-bottom-left-radius: ${props.theme.tooltip.borderRadius};
      border-bottom-right-radius: ${props.theme.tooltip.borderRadius};
    `}
`;
const ListInner = styled.div`
  .tooltip {
    ${TooltipStyles}
  }
`;
export {
  ClipText,
  Container,
  Input,
  ListContainer,
  ListInner,
  Option,
  OptionImage,
  Pill,
  PillsWrapper,
  RemovePill,
  SearchBar,
  Status,
  StatusWrapper
};
